import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
} from "reactstrap";
import AddEditStudyScreening from "./AddEditStudyScreening";
import { ScreeningFormValues, ScreeningMaster } from "../helper/studyscreening.types";

interface AddEditScreeningModalProps {
  isOpen: boolean;
  toggle: () => void;
  editRecord: ScreeningMaster | null;
  mapRecordToForm: (record: ScreeningMaster) => Partial<ScreeningFormValues>;
  onSave: (data: ScreeningFormValues | Partial<ScreeningFormValues>) => void;
  setSubmitHandler: (handler: (() => void) | null) => void;
  setIsSubmitting: (value: boolean) => void;
  submitHandler: (() => void) | null; // ← add this
  isSubmitting: boolean;
  isPending: boolean;
}

const AddEditScreeningModal: React.FC<AddEditScreeningModalProps> = ({
  isOpen,
  toggle,
  editRecord,
  mapRecordToForm,
  onSave,
  setSubmitHandler,
  submitHandler,
  setIsSubmitting,
  isSubmitting,
  isPending,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      backdrop="static"
      className="common_modal"
    >
      <ModalHeader toggle={toggle} className="p-3">
        {editRecord
          ? `Edit Screening (${editRecord.studyscreeningname})`
          : "Add Screening"}
      </ModalHeader>
      <ModalBody>
        <AddEditStudyScreening
          existingData={editRecord ? mapRecordToForm(editRecord) : undefined}
          onSave={onSave}
          setSubmitHandler={setSubmitHandler}
          setSubmitState={setIsSubmitting}
        />
      </ModalBody>
      {submitHandler && (
        <ModalFooter className="bg-white border-top">
          <Button color="dark" onClick={toggle} outline>
            Cancel
          </Button>
          <Button
            color="primary"
            outline
            disabled={isSubmitting}
            onClick={() => submitHandler?.()}
          >
            {isPending && <Spinner size="sm" className="me-2" />}
            Save
          </Button>
        </ModalFooter>
      )}
    </Modal>
  );
};

export default AddEditScreeningModal;
